module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "vacation"
  }, [_c('dt', {
    class: _vm.vacation.status
  }, [_vm._v("Von " + _vm._s(_vm._f("moment")(_vm.vacation.start, 'DD.MM.YYYY')))]), _c('dd', [_vm._v("bis " + _vm._s(_vm._f("moment")(_vm.vacation.end, 'DD.MM.YYYY')) + " - Tage: " + _vm._s(_vm.vacation.used_days))]), (_vm.canDeleteVacation) ? _c('a', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.showConfirmation = true
      }
    }
  }) : _vm._e(), (_vm.showConfirmation) ? _c('div', {
    staticClass: "confirmation"
  }, [_vm._v("Diesen Urlaub wirklich löschen?  "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showConfirmation = false
      }
    }
  }, [_vm._v("nein")]), _c('button', {
    on: {
      "click": _vm.deleteVacation
    }
  }, [_vm._v("ja")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d96c573"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vacation.vue
// module id = 1087
// module chunks = 1